export default __webpack_public_path__ + "static/media/ndvi-legend.186e8c27.png";